import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import NatTokenRepo from '../token/repository/NatTokenRepo'
import {NatGetToken} from '../token/repository/NatGetToken'
import {DO_OR_NOT, FIRST_LOGIN_REFERRER_ID, HOPE_DO_OR_NOT, SEX_MASTER} from '../../../CodeMaster'
import {
    convertToRoomNumberForResident,
    getQueryParameter,
    getStringOrEmptyString,
    NatAsyncCallFunction,
} from '../../common/util/Natutil'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatResidentUserRepo, {
    RegisterResidentUserRequest,
    UpdateResidentUserLoginedRequest,
} from '../residentUser/repository/NatResidentUserRepo'
import {ContentsSubTitleInner, ContentsSubTitleWrapper, ParagraphText} from '../../../styledComponents/ContentsArea'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'

import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import {DisplayItemLabelDiv} from '../../../styledComponents/DisplayItem'
import {CenterPlainLinkStyledButton, PrimaryStyledButton} from '../../../styledComponents/Button'
import {Box, Checkbox} from '@mui/material'
import {formatDateZeroPadding} from '../../../formatters/formatDate'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Messages} from '../../../Messages'
import {NatPostResidentUser} from '../residentUser/repository/NatPostResidentUser'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {
    BlockSpacer,
    currentMedia,
    GridItem,
    LabeledGridContainer,
} from '../../../styledComponents/ResponsiveConvenience'
import {LeftRowFlexContainer, RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Location} from 'react-router-dom'

interface FirstLoginLocationState {
    firstLoginReferrerId: string
    policyAgreeType: string
    residentUserType: string
    dIspStepInfo: DIspStepInfo
    firstLoginUserInfoInput: {
        parentResidentId: string,
        condominiumCd: string,
        condominiumName: string,
        ridgeName: string,
        roomNumber: string,
        familyName: string,
        firstName: string,
        familyNameKana: string,
        firstNameKana: string,
        mailAddress: string,
        birthday: string,
        sex: string,
        wishToHasekoGroupInfos?: string,
        wishToHasekoGroupInfosDispFlg?: boolean,
        sutekiNetOfNotice?: string,
        accessControlDiv?: string
        receivingAgencyCd?: string
        isOwnershipTransfer?: boolean
    }
    userInfoLogind: {
        hasekoId: string,
        familyName: string
        firstName: string
        familyNameKana: string
        firstNameKana: string
        sex: string
        mailAddress: string
        birthday: string
        condominiumName: string
        ridgeName: string
        roomNumber: string,
    }
    authenticationKey: string
    version: number
}

interface Props {
    residentUserRepo: NatResidentUserRepo
    tokenRepo: NatTokenRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    location: Location<FirstLoginLocationState>
}

interface States {
    nowStep: Step
    wishToHasekoGroupInfos: string
    name: string
    nameKane: string
    mailAddress: string
    birthday: string
    sex: string
    wishToHasekoGroupInfosDisplayFlag: boolean
    sutekiNetOfNoticeDisplayFlag: boolean
    sutekiNetOfNoticeFormFlag: boolean
    sutekiNetOfNotice: string,
    isLoadCompleted: boolean
}

class NatResidentFirstLoginUserInfoConfirmPage extends Component<Props & ResidentPagePropsSet, States> {
    firstLoginLocationState: FirstLoginLocationState
    queryToken: string
    isOwnershipTransfer: boolean

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            nowStep: Step.SUB_USER_CONFIRM,
            wishToHasekoGroupInfos: DO_OR_NOT.DO.value,
            name: '',
            nameKane: '',
            mailAddress: '',
            birthday: '',
            sex: '',
            wishToHasekoGroupInfosDisplayFlag: false,
            sutekiNetOfNoticeDisplayFlag: false,
            sutekiNetOfNoticeFormFlag: false,
            sutekiNetOfNotice: DO_OR_NOT.DO.value,
            isLoadCompleted: false,
        }
        const locationState = this.props.location.state
        // @ts-ignore
        this.firstLoginLocationState = (locationState) ? locationState.firstLoginLocationState : []
        this.queryToken = getQueryParameter('token', this.props.location.search)
        this.isOwnershipTransfer = this.firstLoginLocationState.firstLoginUserInfoInput?.isOwnershipTransfer ?? false

        if (!locationState) {
            window.location.href = `/resident/error`
            return
        }

        this.systemErrorTransition = this.systemErrorTransition.bind(this)
        this.onChangeWishToHasekoGroupInfos = this.onChangeWishToHasekoGroupInfos.bind(this)
        this.onChangeSutekiNetOfNotice = this.onChangeSutekiNetOfNotice.bind(this)
        this.registerButtonClick = this.registerButtonClick.bind(this)
        this.backButtonClick = this.backButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const systemErrorMessageId =
            this.isOwnershipTransfer ? Messages.ERESR0013.toString() : Messages.ERESR0003.toString()

        if (this.firstLoginLocationState.firstLoginReferrerId !== FIRST_LOGIN_REFERRER_ID.FLP_LINK_GUIDE.value &&
            this.firstLoginLocationState.firstLoginReferrerId !== FIRST_LOGIN_REFERRER_ID.HASEKO_ID_CONFIRM.value) {
            if (this.queryToken === '') {
                if (!this.firstLoginLocationState.firstLoginUserInfoInput ||
                    !this.firstLoginLocationState.firstLoginUserInfoInput.parentResidentId) {
                    this.props.navigate('/resident/error', {
                        state: {
                            message: systemErrorMessageId,
                            nonDisplayBackBtnFlag: this.isOwnershipTransfer,
                        },
                    })
                    return
                } else {
                    this.props.navigate('/resident/error', {state: {message: Messages.ERESR0004.toString()}})
                    return
                }
            } else {
                await this.props.eventEmitter.showLoading()
                try {
                    // トークンチェック
                    const retToken: Nullable<NatGetToken> =
                        await NatAsyncCallFunction(this.props.tokenRepo.getToken.bind(
                            this.props.tokenRepo, this.queryToken), this.props.navigate, this.systemErrorTransition)

                    if (retToken === null) {
                        return
                    }

                    if (retToken && retToken.details === null) {
                        if (this.firstLoginLocationState.firstLoginUserInfoInput.parentResidentId === '' ||
                            this.firstLoginLocationState.firstLoginUserInfoInput.parentResidentId === null) {
                            this.props.navigate('/resident/error', {
                                state: {
                                    message: systemErrorMessageId,
                                    nonDisplayBackBtnFlag: this.isOwnershipTransfer,
                                },
                            })
                            return
                        } else {
                            this.props.navigate('/resident/error', {state: {message: Messages.ERESR0004.toString()}})
                            return
                        }
                    }
                } finally {
                    this.props.eventEmitter.closeLoading()
                }
            }
        }

        // ユーザ情報
        let name: string = ''
        let nameKane: string = ''
        let mailAddress: string = ''
        let birthday: string = ''
        let sex: string = ''
        if (this.firstLoginLocationState.firstLoginReferrerId !== FIRST_LOGIN_REFERRER_ID.FLP_LINK_GUIDE.value) {
            name = getStringOrEmptyString(this.firstLoginLocationState.firstLoginUserInfoInput.familyName) + ' ' +
                getStringOrEmptyString(this.firstLoginLocationState.firstLoginUserInfoInput.firstName)
            nameKane = getStringOrEmptyString(this.firstLoginLocationState.firstLoginUserInfoInput.familyNameKana) + ' '
                + getStringOrEmptyString(this.firstLoginLocationState.firstLoginUserInfoInput.firstNameKana);
            mailAddress = this.firstLoginLocationState.firstLoginUserInfoInput.mailAddress;
            birthday = this.firstLoginLocationState.firstLoginUserInfoInput.birthday ?
                formatDateZeroPadding(this.firstLoginLocationState.firstLoginUserInfoInput.birthday) : '';
            const sexMaster: any =
                SEX_MASTER.codeToEnumConstants(this.firstLoginLocationState.firstLoginUserInfoInput.sex)
            if (sexMaster !== undefined) {
                sex = sexMaster.label
            }
        } else {
            name = getStringOrEmptyString(this.firstLoginLocationState.userInfoLogind.familyName) + ' ' +
                getStringOrEmptyString(this.firstLoginLocationState.userInfoLogind.firstName)
            nameKane = getStringOrEmptyString(this.firstLoginLocationState.userInfoLogind.familyNameKana) + ' '
                + getStringOrEmptyString(this.firstLoginLocationState.userInfoLogind.firstNameKana)
            mailAddress = this.firstLoginLocationState.userInfoLogind.mailAddress
            birthday = this.firstLoginLocationState.userInfoLogind.birthday ?
                formatDateZeroPadding(this.firstLoginLocationState.userInfoLogind.birthday) : ''
            const sexMaster: any =
                SEX_MASTER.codeToEnumConstants(this.firstLoginLocationState.userInfoLogind.sex)
            if (sexMaster !== undefined) {
                sex = sexMaster.label
            }
        }

        // 現在のSTEP
        let nowStep: Step
        if (this.firstLoginLocationState.firstLoginUserInfoInput) {
            if (this.firstLoginLocationState.firstLoginUserInfoInput.parentResidentId === null) {
                // メインユーザ
                nowStep = Step.USER_CONFIRM
            } else {
                // サブユーザ
                nowStep = Step.SUB_USER_CONFIRM
            }
        } else {
            nowStep = Step.USER_CONFIRM
        }

        let wishToHasekoGroupInfosDisplayFlag: boolean = true
        if (this.firstLoginLocationState.firstLoginUserInfoInput.wishToHasekoGroupInfos === undefined ||
            !this.firstLoginLocationState.firstLoginUserInfoInput.wishToHasekoGroupInfosDispFlg) {
            wishToHasekoGroupInfosDisplayFlag = false
        }

        let sutekiNetOfNoticeDisplayFlag: boolean = true
        if (this.firstLoginLocationState.firstLoginUserInfoInput.sutekiNetOfNotice === undefined) {
            sutekiNetOfNoticeDisplayFlag = false
        }

        let sutekiNetOfNoticeFormFlag: boolean = true
        if (this.firstLoginLocationState.firstLoginUserInfoInput.sutekiNetOfNotice !== undefined) {
            sutekiNetOfNoticeFormFlag = false
        }

        this.setState({
            nowStep: nowStep,
            name: name,
            nameKane: nameKane,
            mailAddress: mailAddress,
            birthday: birthday,
            sex: sex,
            wishToHasekoGroupInfosDisplayFlag: wishToHasekoGroupInfosDisplayFlag,
            sutekiNetOfNoticeDisplayFlag: sutekiNetOfNoticeDisplayFlag,
            sutekiNetOfNoticeFormFlag: sutekiNetOfNoticeFormFlag,
            isLoadCompleted: true,
        })
    }

    // システムエラー遷移
    systemErrorTransition(): void {
        this.props.navigate(`/resident/error`, {
            state: {
                message: Messages.ESYCC0018.toString(),
                nonDisplayBackBtnFlag: this.isOwnershipTransfer,
            },
        })
    }

    onChangeWishToHasekoGroupInfos(event: React.ChangeEvent<HTMLInputElement>): void {
        const checked = (event.target.checked) ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value
        this.setState({wishToHasekoGroupInfos: checked})
    }

    onChangeSutekiNetOfNotice(event: React.ChangeEvent<HTMLInputElement>): void {
        const checked = (event.target.checked) ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value
        this.setState({sutekiNetOfNotice: checked})
    }

    // STEP
    renderStep(): Nullable<ReactElement> {
        if (!this.firstLoginLocationState.dIspStepInfo) {
            return null
        } else {
            return (
                <NatStepComponent
                    dIspStepInfo={this.firstLoginLocationState.dIspStepInfo}
                    nowStep={this.state.nowStep}
                />
            )
        }
    }


    // 登録確認メッセージ
    renderConfirmMassage(): ReactElement {
        if (this.firstLoginLocationState.firstLoginReferrerId ===
            FIRST_LOGIN_REFERRER_ID.FLP_LINK_GUIDE.value) {
            return (
                <MessageBlock>
                    <Message>
                        ポイントサービスのご利用には長谷工IDへの登録が必要です。<br/>
                        以下の内容で登録を行いますがよろしいでしょうか？
                    </Message>
                </MessageBlock>
            )
        } else {
            return (
                <MessageBlock>
                    <Message>
                        以下の情報で、登録を行います。
                    </Message>
                </MessageBlock>
            )
        }
    }

    // 物件情報
    renderCondominiumInfo(): Nullable<ReactElement> {
        if (this.firstLoginLocationState.firstLoginReferrerId === FIRST_LOGIN_REFERRER_ID.FLP_LINK_GUIDE.value) {
            return null
        }
        const roomNumber: string = this.firstLoginLocationState.firstLoginUserInfoInput.ridgeName +
            convertToRoomNumberForResident(this.firstLoginLocationState.firstLoginUserInfoInput.roomNumber)
        return (
            <>
                {this.renderItem('マンション名', this.firstLoginLocationState.firstLoginUserInfoInput.condominiumName)}
                <BlockSpacer height={'5px'}/>
                {this.renderItem('部屋番号', roomNumber)}
            </>
        )
    }

    // ブランシエラクラブ
    mailMagazineDeliveryHope(): ReactElement {
        const {wishToHasekoGroupInfosDisplayFlag, sutekiNetOfNoticeDisplayFlag, sutekiNetOfNoticeFormFlag} = this.state
        const {wishToHasekoGroupInfos, sutekiNetOfNotice} = this.firstLoginLocationState.firstLoginUserInfoInput

        const hasekoGroupInfosLabel = wishToHasekoGroupInfos === DO_OR_NOT.NOT.value ?
            HOPE_DO_OR_NOT.NOT_HOPE.label : HOPE_DO_OR_NOT.HOPE.label
        const sutekiNetOfNoticeLabel = sutekiNetOfNotice === DO_OR_NOT.NOT.value ?
            HOPE_DO_OR_NOT.NOT_HOPE.label : HOPE_DO_OR_NOT.HOPE.label

        return (
            <>
                <Box>メールマガジン配信希望</Box>
                <Box height={'5px'}/>
                {wishToHasekoGroupInfosDisplayFlag &&
                    <>
                        {this.renderItem(<>長谷工グループ<BreakPcOnly/>「ブランシエラクラブ」</>, hasekoGroupInfosLabel, 'center')}
                        <BlockSpacer height={'5px'}/>
                    </>
                }
                {sutekiNetOfNoticeDisplayFlag &&
                    <>
                        {this.renderItem('すてきテラス', sutekiNetOfNoticeLabel)}
                        <BlockSpacer height={'5px'}/>
                    </>
                }
                {sutekiNetOfNoticeFormFlag &&
                    <InfosWhiteArea>
                        <Box height={'10px'}/>
                        <Box>
                            <LeftRowFlexContainer>
                                <Checkbox
                                    name="sutekiNetOfNotice"
                                    color="default"
                                    checked={(this.state.sutekiNetOfNotice !== DO_OR_NOT.NOT.value)}
                                    onChange={this.onChangeSutekiNetOfNotice}
                                />
                                すてきテラス
                            </LeftRowFlexContainer>
                            <InfosContainer>
                                「すてきテラス」よりマンションに関するサービスのご紹介や暮らしに役立つ情報などを定期的にお届けいたします。
                            </InfosContainer>
                        </Box>
                        <Box height={'15px'}/>
                        <Box padding={'0 9px'} fontSize={FontSize.Small} color={Colors.AccentDark}>
                            ※メールマガジン内のリンクよりいつでも配信停止できます。
                        </Box>
                        <Box height={'15px'}/>
                    </InfosWhiteArea>
                }
            </>
        )
    }

    renderHasekoIdNotificationNote(): Nullable<ReactElement> {
        const {wishToHasekoGroupInfosDisplayFlag, sutekiNetOfNoticeDisplayFlag, sutekiNetOfNoticeFormFlag} = this.state

        let deliverySource: string = ''
        if (wishToHasekoGroupInfosDisplayFlag) {
            deliverySource = '長谷工IDに関するお知らせ及び、長谷工グループ「ブランシエラクラブ」'
        }
        if (sutekiNetOfNoticeDisplayFlag || sutekiNetOfNoticeFormFlag) {
            deliverySource = deliverySource + '「すてきテラス」'
        }

        return (
            <>
                <Box fontSize={FontSize.Middle}>【注意事項】</Box>
                <ListGridContainer>
                    <div>・</div>
                    <div>{deliverySource}のメールマガジンは、@haseko.co.jpより配信されます。</div>
                    <div>・</div>
                    <div>プロバイダやメールソフトの設定などにより、受信ができない場合がございます。</div>
                    <div>・</div>
                    <div>上記メールが受信できるように、迷惑メール設定・ドメイン指定受信の設定をお願いいたします。設定方法はご契約のプロバイダのWebサイトをご確認ください。</div>
                </ListGridContainer>
            </>
        )
    }

    // 前へ戻る
    backButtonClick(): void {
        const {firstLoginUserInfoInput} = this.firstLoginLocationState
        const ownershipTransferParam = firstLoginUserInfoInput.isOwnershipTransfer ? '&ownershipTransfer' : ''

        switch (this.firstLoginLocationState.firstLoginReferrerId) {
            case FIRST_LOGIN_REFERRER_ID.USER_INFO_INPUT.value:
                this.props.navigate(
                    `/resident/firstLoginUserInfoInput?token=${this.queryToken}${ownershipTransferParam}`,
                    {
                        state: {
                            firstLoginLocationState: {
                                firstLoginReferrerId: FIRST_LOGIN_REFERRER_ID.USER_INFO_INPUT_CONFIRM.value,
                                policyAgreeType: this.firstLoginLocationState.policyAgreeType,
                                dIspStepInfo: this.firstLoginLocationState.dIspStepInfo,
                                firstLoginUserInfoInput: this.firstLoginLocationState.firstLoginUserInfoInput,
                                authenticationKey: this.firstLoginLocationState.authenticationKey,
                            },
                        },
                    },
                )
                break
            case FIRST_LOGIN_REFERRER_ID.HASEKO_ID_CONFIRM.value:
                this.props.navigate(
                    `/resident/firstLoginHasekoIdConfirm?token=${this.queryToken}`,
                    {
                        state: {
                            firstLoginLocationState: {
                                policyAgreeType: this.firstLoginLocationState.policyAgreeType,
                                residentUserType: this.firstLoginLocationState.residentUserType,
                                dIspStepInfo: this.firstLoginLocationState.dIspStepInfo,
                                authenticationKey: this.firstLoginLocationState.authenticationKey,
                            },
                        },
                    },
                )
                break
            case FIRST_LOGIN_REFERRER_ID.HASEKO_PASSWORD_CONFIRM.value:
                this.props.navigate(
                    `/resident/firstLoginHasekoIdPasswordConfirm?token=${this.queryToken}${ownershipTransferParam}`,
                    this.firstLoginLocationState?.dIspStepInfo ?
                        {
                            state:
                                {
                                    firstLoginLocationState: {
                                        dIspStepInfo: this.firstLoginLocationState.dIspStepInfo,
                                    }
                                }
                        } : undefined,
                )
                break
            case FIRST_LOGIN_REFERRER_ID.SUTEKI_PASSWORD_CONFIRM.value:
                this.props.navigate(
                    `/resident/firstLoginSutekiPasswordConfirm?token=${this.queryToken}${ownershipTransferParam}`,
                    {
                        state: {
                            firstLoginLocationState: {
                                firstLoginUserInfoInput: this.firstLoginLocationState.firstLoginUserInfoInput,
                            },
                        },
                    },
                )
                break
            default:
                this.props.navigate(-1)
                break
        }
    }

    // 登録する
    async registerButtonClick(): Promise<void> {
        const {firstLoginUserInfoInput} = this.firstLoginLocationState

        await this.props.eventEmitter.showLoading()
        try {
            if (this.firstLoginLocationState.firstLoginReferrerId === FIRST_LOGIN_REFERRER_ID.FLP_LINK_GUIDE.value) {
                // 居住者ユーザ更新（ログイン済）
                const request: UpdateResidentUserLoginedRequest = {
                    homeMileageLinkGuideDisplay: DO_OR_NOT.NOT.value,
                    accessControlDiv: DO_OR_NOT.DO.value,
                    wishToHasekoGroupInfos: this.state.wishToHasekoGroupInfos,
                    version: this.firstLoginLocationState.version,
                }
                const ret: Nullable<void> =
                    await NatAsyncCallFunction(this.props.residentUserRepo.updateResidentUserLogined.bind(
                        this.props.residentUserRepo, request), this.props.navigate, this.systemErrorTransition)

                if (ret) {
                    this.props.navigate(
                        `/resident/hasekoIdLinkComplete`,
                        {state: {firstLoginLocationState: this.firstLoginLocationState}},
                    )
                }

            } else {
                let wishToHasekoGroupInfos: string = ''
                if (this.firstLoginLocationState.firstLoginReferrerId ===
                    FIRST_LOGIN_REFERRER_ID.SUTEKI_PASSWORD_CONFIRM.value &&
                    firstLoginUserInfoInput.wishToHasekoGroupInfos) {
                    wishToHasekoGroupInfos = firstLoginUserInfoInput.wishToHasekoGroupInfos
                }

                // 居住者ユーザ登録
                const registerResidentUserRequest: RegisterResidentUserRequest = {
                    token: this.queryToken,
                    authenticationKey: this.firstLoginLocationState.authenticationKey,
                    policyAgreeType: this.firstLoginLocationState.policyAgreeType,
                    wishToHasekoGroupInfos: wishToHasekoGroupInfos,
                    receivingAgencyCd: this.firstLoginLocationState.firstLoginUserInfoInput.receivingAgencyCd,
                    isOwnershipTransfer: this.isOwnershipTransfer,
                }
                if (this.state.sutekiNetOfNoticeFormFlag) {
                    registerResidentUserRequest.sutekiNetOfNotice = this.state.sutekiNetOfNotice
                }

                const ret: Nullable<NatPostResidentUser> =
                    await NatAsyncCallFunction(this.props.residentUserRepo.registerResidentUser.bind(
                            this.props.residentUserRepo, registerResidentUserRequest),
                        this.props.navigate,
                        this.systemErrorTransition,
                    )
                if (ret) {
                    this.props.navigate(
                        `/resident/firstLoginUserInfoRegisterComplete`,
                        {
                            state: {
                                dIspStepInfo: this.firstLoginLocationState.dIspStepInfo,
                                condominiumCd: firstLoginUserInfoInput.condominiumCd,
                                receivingAgencyCd: firstLoginUserInfoInput.receivingAgencyCd,
                                isOwnershipTransfer: this.isOwnershipTransfer,
                            },
                        },
                    )
                }
            }
        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                this.props.navigate(
                    `/resident/error`,
                    {
                        state: {
                            message: errorResponseBody.requestError.message,
                            nonDisplayBackBtnFlag: this.isOwnershipTransfer,
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    renderItem(title: string | ReactElement, item: string, alignItems?: string): ReactElement {
        return <ItemDiv>
            <LabeledGridContainer alignItems={alignItems ? alignItems : 'flex-start'}>
                <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>{title}</Box></DisplayItemLabelDiv>
                </GridItem>
                <GridItem over={9}>
                    <RowFlexContainer><TextContents>{item}</TextContents></RowFlexContainer>
                </GridItem>
            </LabeledGridContainer>
        </ItemDiv>
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                {this.renderStep()}
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        ユーザ情報の登録確認
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                {this.renderConfirmMassage()}
                {this.renderCondominiumInfo()}
                <BlockSpacer height={'5px'}/>
                {this.renderItem('氏名', this.state.name)}
                <BlockSpacer height={'5px'}/>
                {this.renderItem('フリガナ', this.state.nameKane)}
                <BlockSpacer height={'5px'}/>
                {this.renderItem('メールアドレス', this.state.mailAddress)}
                <BlockSpacer height={'5px'}/>
                {this.renderItem('生年月日', this.state.birthday)}
                <BlockSpacer height={'5px'}/>
                {this.renderItem('性別', this.state.sex)}
                <BlockSpacer height={'20px'}/>
                {this.mailMagazineDeliveryHope()}
                <BlockSpacer height={'15px'}/>
                {this.renderHasekoIdNotificationNote()}
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton
                    onClick={this.registerButtonClick}>
                    登録する
                </PrimaryStyledButton>
                <BlockSpacer height={'30px'}/>
                <CenterPlainLinkStyledButton onClick={this.backButtonClick}>
                    {this.firstLoginLocationState.firstLoginReferrerId === FIRST_LOGIN_REFERRER_ID.USER_INFO_INPUT.value
                        ? '修正する'
                        : '戻る'}
                </CenterPlainLinkStyledButton>
                <BlockSpacer height={'30px'}/>
            </>
        )
    }
}

export default createResidentPage(NatResidentFirstLoginUserInfoConfirmPage)

// メッセージブロック
const MessageBlock: StyledDiv = styled.div`
  text-align: center;
`
// メッセージ
const Message = styled(ParagraphText)`
  display: inline-block;
  text-align: left;
`

const ItemDiv = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    margin: 0px -15px;
  `}
  padding: 20px 15px 20px 15px;
`

const TextContents = styled.div`
  font-weight: ${FontWeights.Bold};
`

const BreakPcOnly = styled.br`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`

const InfosWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 7px;
  box-sizing: border-box;
  overflow: hidden;
`

const InfosContainer: StyledDiv = styled.div`
  padding: 0 15px 0 33px;
  font-size: ${FontSize.Middle};
`

const ListGridContainer = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  font-size: 　${FontSize.Middle}
`
